










































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import HandoverSessionDetail from "@/store/entities/handoversessiondetail";
import HandoverSession from "@/store/entities/handoversession";
import PageRequest from "@/store/entities/page-request";
import AppConsts from "@/lib/appconst";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import sessionLineColumns from "./handoversessionline-columns";
import Barcode from "../../components/bar-code.vue";
import DateTimeMixin from "@/components/mixin/date-time-mixin";

class PageHandoverSessionLineRequest extends PageRequest {
  keyword: string;
}
@Component({
  components: { "bar-code": Barcode },
})
export default class ViewHandoverSession extends mixins(
  ListMixin,
  DateTimeMixin,
  AbpBase
) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  session: HandoverSessionDetail = new HandoverSessionDetail();
  id: number = 0;
  spinShow: boolean = false;
  namespace = "handoverSessionLine";
  pagerequest: PageHandoverSessionLineRequest =
    new PageHandoverSessionLineRequest();
  packages = [];
  get store() {
    return this.$store.state.handoverSessionLine;
  }
  showSuccessMsg(msg: string) {
    Util.showSuccessMsg(this, msg);
  }
  sessionCancelled() {
    return this.session.status === AppConsts.handoverSessionStatus.canceled;
  }
  canTransfer() {
    return (
      this.hasPermission("Operations.HandoverSession.Transfer") &&
      this.session.notDone
    );
  }
  canDelete() {
    return (
      this.hasPermission("Operations.HandoverSession.Delete") &&
      this.session.canDelete
    );
  }
  onGoBack() {
    this.$root.$router.push({ name: "handoversession" });
  }
  async exportToExcel() {
    await this.$store.dispatch({
      type: "handoverSessionLine/export",
      data: { code: this.session.code, id: this.session.id },
    });
  }

  printCustomerReport() {
    var url = `/#/handover-customer-report/${this.id}`;
    window.open(url, "_blank");
  }
  printTplReport() {
    var url = `/#/handover-tpl-report/${this.id}`;
    window.open(url, "_blank");
  }

  deleteSession() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.DeleteHandoverSession"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          await this.$store.dispatch({
            type: "handoverSession/delete",
            data: this.session.id,
          });
          this.showSuccessMsg("Success.DeleteHandoverSession");
          this.$root.$router.push({ name: "handoversession" });
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  transferSession() {
    var confirmContent = this.L("Confirm.TransferHandoverSession");
    if (this.session.notDone) {
      confirmContent = this.L("Confirm.TransferNotDoneHandoverSession");
    }
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: confirmContent,
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          await this.$store
            .dispatch({
              type: "handoverSession/transfer",
              data: { Id: this.session.id },
            })
            .then((re) => {
              if (!Util.isNull(re) && !Util.isEmpty(re)) {
                Util.showWarningMsg(this, re);
              } else {
                this.showSuccessMsg("Success.TransferHandoverSession");
              }
            });
          this.refreshPage();
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  async created() {
    this.spinShow = true;
    try {
      this.id = +this.$root.$router.currentRoute.params.id;
      await this.refreshPage();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
  async refreshPage() {
    await this.$store
      .dispatch({
        type: "handoverSession/get",
        data: { id: this.id },
      })
      .then((result) => {
        this.session = result;
        this.packages = result.items;
        this.getpage();
      });
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    var items = this.packages;
    if (
      !Util.isNull(this.pagerequest.keyword) &&
      !Util.isEmpty(this.pagerequest.keyword)
    ) {
      var code = this.pagerequest.keyword;
      items = items.filter((item) => item.packageNo.indexOf(code) >= 0);
    }
    this.store.list = Util.pagingItems(items, this.pageSize, this.currentPage);
    this.store.totalCount = items.length;
  }
  get list() {
    var re = this.store.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function (item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  columns = sessionLineColumns;
}
